// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner___MUsc","subtitle":"styles_subtitle__2lWGH","imageAbout":"styles_imageAbout__2HqvK"};